import React from 'react'
import AdminLayout from '../../../layouts/AdminLayout';
import HousekeepingTable from '../components/HousekeepingTable';
import RoomStatusJumbotron from '../components/RoomStatusJumbotron';
import PropertyInactiveBanner from '../../../shared/components/PropertyInactiveBanner';


const HousekeepingPage: React.FC = () => {
    const getAuthToken = localStorage.getItem('authToken');

    return (
        <AdminLayout>
            <div className="container-fluid mt-5">
                <div className="table-container">
                    <h3 className="mb-3">Housekeeping</h3>
                    <PropertyInactiveBanner />
                    <RoomStatusJumbotron
                        housekeepingUrl={`${import.meta.env.VITE_APP_URL}/housekeeping/${getAuthToken}`}
                    />

                    <HousekeepingTable />
                </div>
            </div>
        </AdminLayout>
    )
}

export default HousekeepingPage